const deriveReason = ({
  deliveryAttempted,
  painted,
  isSorted,
  sponsoredProductIds,
}) => {
  if (!deliveryAttempted || painted) return null;

  const hasWhitelist = !!sponsoredProductIds;

  if (isSorted && !hasWhitelist) return "sortedAndEmpty";
  if (isSorted) return "sorted";
  if (!hasWhitelist) return "emptyWhitelist";

  return "other";
};

export default deriveReason;
